import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReflectionService } from '../../../../../_services/reflection.service';
import { UtilityService } from 'src/app/_services/utility.service';
import { Reflection, Typology } from '../../../../../models/reflection';
import { Response } from '../../../../../models/response';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-generic-reflection-widget',
  templateUrl: './generic-reflection-widget.component.html',
  styleUrls: ['./generic-reflection-widget.component.css']
})
export class GenericReflectionWidgetComponent {
  @Input() reflection: Reflection | null;
  @Input() userProjects: any;
  @Input() onlyShow: boolean = false;

  formValidator: FormGroup;
  isUpdating: boolean = false;
  selectedProject: any;
  today: string;
  startDate: string;
  selectedTypology: Typology;
  typologyIconList: Typology[];
  allDataIsInit: boolean = false;
  modalIsVisible: boolean = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly reflectionService: ReflectionService,
    public readonly utilityService: UtilityService
  ) {
    this._initFormFormValidator();

    this.today = new Date().toISOString().split('T')[0];
  }

  ngOnInit(): void {
    if (this.reflection) {
      this.populateTypologyIcons();
      this.selectedTypology = this.findTypologyById(
        this.reflection.learnedlesson_typology.id
      ) as Typology;
      this.allDataIsInit = true;
    }
  }

  selectProject(selected: any): void {
    this.selectedProject = selected;
    if (this.reflection === null) return;

    this.formValidator.value.project_id = selected.id;
    this.reflection.project_user_id = selected.id;
    this.reflection.project_user.project.id = selected.id;
    this.reflection.project_user.project.filestorage = selected.filestorage;
    this.reflection.project_user.project.alias = selected.alias;
  }

  selectTypology(typology: Typology): void {
    if (this.reflection === null) return;

    this.selectedTypology = typology;
    this.reflection.learnedlesson_typology.alias = typology.name;
    this.reflection.learnedlesson_typology.id = typology.id;
    this.formValidator.value.typology_id = typology.id;
  }

  startEdit(): void {
    if (this.reflection === null) return;

    this.isUpdating = true;
    this.startDate = this.reflection.project_user.startwork_date;
    this._editFormFormValidator();
  }

  updateReflection(): void {
    if (this.reflection === null) return;

    this.reflection.learned_at = this.formValidator.value.learned_at;
    this.reflection.description = this.formValidator.value.description;
    this._editFormFormValidator();

    this.reflectionService.editLesson(this.formValidator.value).subscribe({
      next: (res: Response<any>): void => {
        this.isUpdating = false;
      },
      error: err => {}
    });
    this.isUpdating = false;
  }

  deleteReflection(id: number): void {
    Swal.fire({
      text: 'Confermi di voler eliminare ?',
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      cancelButtonColor: '#00337C',
      showConfirmButton: true,
      confirmButtonText: 'Conferma',
      confirmButtonColor: '#FFB26B',
      reverseButtons: true,
      customClass: {
        popup: 'main-font'
      },
      backdrop: '#f4f3efad',
      position: 'center',
      target: '.mat-card-content'
    }).then(result => {
      if (result.isConfirmed) {
        this.reflectionService.deleteRiflessione(id).subscribe(res => {
          this.reflection = null;
        });

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      }
    });
  }

  _editFormFormValidator(): void {
    if (this.reflection === null) return;

    this.formValidator.patchValue({
      description: this.reflection.description,
      task_id: this.reflection.task_id,
      typology_id: this.reflection.learnedlesson_typology.id,
      learned_at: this.reflection.learned_at,
      project_id: this.reflection.project_user.project.id, // cast
      user_id: this.reflection.project_user.user_id, // cast
      id: this.reflection.id
    });
  }

  showModal(): void {
    this.modalIsVisible = true;
  }

  handleCancel(): void {
    this.modalIsVisible = false;
  }

  populateTypologyIcons(): void {
    this.typologyIconList = [
      { id: 1, icon: 'terminal', name: 'Sviluppo' },
      { id: 2, icon: 'local_library', name: 'Formazione' },
      { id: 3, icon: 'groups', name: 'Meeting' },
      { id: 4, icon: 'psychology_alt', name: 'Supporto' },
      { id: 5, icon: 'dvr', name: 'Backoffice' },
      { id: 6, icon: 'query_stats', name: 'Analisi' }
    ];
  }

  findTypologyById(id: number) {
    return this.typologyIconList.find(item => item.id === id);
  }

  _initFormFormValidator(): void {
    this.formValidator = this.formBuilder.group({
      description: [''],
      task_id: [null, Validators.required],
      typology_id: ['', Validators.required],
      learned_at: [null, Validators.required],
      project_id: [null],
      user_id: [''],
      id: [null]
    });
  }
}
